import React from 'react';

const WIP = () => <h1>WIP</h1>

export default WIP;